import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { create, deleteFrom, update } from "../../services/services";
import TextInput from "../../components/inputs/TextInuput";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatUpdateDate } from "../../utils/utils";
import { toast } from "react-toastify";
const MAX_NAME_LENGTH = 19;
const EquipeEtablissement = ({ from, members, setMembers }) => {
  const navigate = useNavigate();
  // const [members, setMembers] = useState([]);
  const [isExpanded, setIsExpanded] = useState(
    from === "account" ? false : true
  );
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { selectedEtablissement } = useSelector(
    (state) => state.etablissements
  );

  // Initialize members with existing team data or default empty member
  useEffect(() => {
    if (selectedEtablissement?.equipes?.length > 0) {
      const initialMembers = selectedEtablissement.equipes.map((member) => ({
        id: member.id || Date.now() + Math.random(),
        name: member.name || "",
        isNew: false, // Mark existing members
      }));
      setMembers(initialMembers);
    } else {
      // Set default empty member if no team exists
      setMembers([{ id: Date.now(), name: "", isNew: true }]);
    }
  }, [selectedEtablissement?.equipes]);

  useEffect(() => {
    dispatch(getMyEtablissement());
  }, [dispatch]);

  const handleMemberChange = (id, value) => {
    setMembers(
      members.map((member) =>
        member.id === id ? { ...member, name: value, hasChanged: true } : member
      )
    );
  };

  const handleAddMember = () => {
    setMembers([...members, { id: Date.now(), name: "", isNew: true }]);
  };

  const handleRemoveMember = (id, isNew) => {
    // if (members.length > 1) {
      if (isNew) {
        setMembers(members.filter((member) => member.id !== id));
      } else {
        deleteFrom(`equipes/${id}`)
          .then((res) => {
            // console.log(res)
            setMembers(members.filter((member) => member.id !== id));
            toast.success(
              "Suppression effectuée : le membre a bien été retiré"
            );
          })
          .catch((err) => {
            // console.log({err})
            toast.error(err?.response?.data?.message);
            // console.log(err)
          });
      }
    // } else {
    //   setError("Vous devez avoir au moins un membre");
    //   setTimeout(() => setError(""), 3000);
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validMembers = members.filter((member) => member.name.trim() !== "");
    // Separate new members (to be created) and existing members (to be updated)
    const newMembersToCreate = validMembers.filter((member) => member.isNew);
    const existingMembersToUpdate = validMembers.filter(
      (member) => !member.isNew && member.hasChanged // Assuming you track changes
    );
    // console.log({existingMembersToUpdate})
    const newMembersToSave = members.filter(
      (member) => member.isNew && member.name.trim() !== ""
    );
    if (existingMembersToUpdate.length > 0) {
      await Promise.all(
        existingMembersToUpdate.map((member) =>
          update(`equipes/${member.id}`, { name: member.name, status: "0" })
            .then(() => {
              if (from !== "account") {
                navigate("/confirm");
              }
              toast.success(
                "Informations de l'établissement mises à jour avec succès"
              );
              // Refresh establishment data after update
              dispatch(getMyEtablissement());
            })
            .catch((err) => {
              // console.error(err);
              setError("Une erreur est survenue lors de l'enregistrement");
            })
        )
      );
    }
    if (newMembersToSave.length === 0) {
      if (from !== "account") {
        navigate("/confirm");
      }
      return;
    }

    const teamData = newMembersToSave.map((member) => ({
      name: member.name,
      etablissement_id: selectedEtablissement?.id,
      status: "active",
    }));

    create(teamData, "equipes")
      .then(() => {
        if (from !== "account") {
          navigate("/confirm");
        }
        toast.success(
          "Informations de l'établissement mises à jour avec succès"
        );
        // Refresh establishment data after update
        dispatch(getMyEtablissement());
      })
      .catch((err) => {
        // console.error(err);
        setError("Une erreur est survenue lors de l'enregistrement");
      });
    // 2. Update existing members (if any)
  };

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        {from === "account" ? (
          <h4 className="grey500">
            Votre équipe <span className="body grey66">(facultatif)</span>
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <img
                src="/images/chevron-down.svg"
                className={`w-6 h-6 ${!isExpanded ? "rotate180" : ""}`}
                alt={isExpanded ? "Réduire" : "Ouvrir"}
              />
            </button>
          </h4>
        ) : (
          <h3 className="grey500">
            Votre équipe <span className="body grey66">(facultatif)</span>
          </h3>
        )}
        {from === "account" && (
          <div className="d-flex align-items-center">
            {selectedEtablissement?.updated_at && (
              <span className="body grey66 mr-16">
                Dernière mise à jour:{" "}
                {formatUpdateDate(selectedEtablissement.updated_at)}
              </span>
            )}
          </div>
        )}
      </div>

      {isExpanded && (
        <>
          <p className="body mt-32 grey66500">
            Présentez votre équipe en ajoutant chaque membre. Vos clients
            pourront indiquer leur préférence pour un membre spécifique de
            l'équipe lors de la prise de rendez-vous.
          </p>

          {members.map((member) => (
            <div key={member.id} className="d-flex align-items-end mt-8">
              <div className="col">
                {/* <TextInput
                  label={`Membre ${members.indexOf(member) + 1}`}
                  placeholder="Nom ou prénom"
                  value={member.name}
                  onChange={(e) => handleMemberChange(member.id, e.target.value)}
                  className="padding-input-text"
                /> */}
                <div className="input-wrapper">
                  <label className="form-label">{`Membre ${
                    members.indexOf(member) + 1
                  }`}</label>
                  <input
                    name={""}
                    className="form-control"
                    onChange={(e) =>
                      handleMemberChange(member.id, e.target.value)
                    }
                    value={member.name}
                    placeholder="Nom ou prénom"
                    aria-required="true"
                    type="text"
                    maxLength={MAX_NAME_LENGTH}
                  />
                </div>
              </div>
              <div className="col-auto">
                <button
                  type="button"
                  className="twyny-cta-secondary btn-withIcon p-12 ml-8"
                  onClick={() => handleRemoveMember(member.id, member?.isNew)}
                  // disabled={members.length <= 1}
                >
                  <img src="/images/trash.svg" className="arrow" alt="Delete" />
                </button>
              </div>
            </div>
          ))}

          <div className="mt-16">
            <button
              type="button"
              className="link-blue"
              onClick={handleAddMember}
            >
              <img src="/images/plus-01.svg" className="arrow mr-8" alt="Add" />
              Ajouter un membre
            </button>
          </div>

          {error && (
            <span className="error-message mt-8">
              <img
                src="/images/alert-circle.svg"
                className="arrow mr-8"
                alt="Error"
              />
              {error}
            </span>
          )}

          {from === "account" && (
            <button
              type="submit"
              onClick={handleSubmit}
              className="twyny-cta-primary w-100 mt-24"
            >
              Enregistrer les modifications
            </button>
          )}
        </>
      )}
    </>
  );
};

export default EquipeEtablissement;
